import styles from "@/components/directory/v2/list-view/EVsListsManager.module.css";
import EVsListComponent from "@/components/directory/v2/list-view/EVsListComponent";

const EVsListsManager = ({results}) => {
  return (
    <div className={styles.container}>
      {results.map((result, index) => (
        <EVsListComponent key={index} result={result}/>
      ))}
    </div>
  )
}

export default EVsListsManager;